import React from 'react'
import { Text, makeStyles, tokens } from '@fluentui/react-components'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalS,
    marginBottom: tokens.spacingVerticalS,
  },
  label: {
    color: tokens.colorNeutralForeground2,
    whiteSpace: 'nowrap',
  },
  // The rule runs from the label to the edge, as Office panes group content.
  rule: {
    flexGrow: 1,
    height: '1px',
    backgroundColor: tokens.colorNeutralStroke2,
  },
  action: {
    flexShrink: 0,
  },
})

export interface SectionHeaderProps {
  children: React.ReactNode
  /** Optional trailing control, e.g. a count or a "View all" link. */
  action?: React.ReactNode
}

/** A section label followed by a rule, the grouping pattern Office task panes use. */
export const SectionHeader: React.FC<SectionHeaderProps> = ({ children, action }) => {
  const styles = useStyles()

  return (
    <div className={styles.root}>
      <Text weight="semibold" size={300} className={styles.label}>
        {children}
      </Text>
      <span className={styles.rule} aria-hidden="true" />
      {action && <span className={styles.action}>{action}</span>}
    </div>
  )
}
